export const CHECK_COMMON_TASKS_REQUEST = 'CHECK_COMMON_TASKS_REQUEST';
export const CHECK_COMMON_TASKS_SUCCESS = 'CHECK_COMMON_TASKS_SUCCESS';
export const CHECK_COMMON_TASKS_FAILURE = 'CHECK_COMMON_TASKS_FAILURE';
export const CANCEL_ASSIGN_REQUEST = 'CANCEL_ASSIGN_REQUEST';
export const ACTIVATE_MODAL_REQUEST = 'ACTIVATE_MODAL_REQUEST';
export const DEACTIVATE_MODAL_REQUEST = 'DEACTIVATE_MODAL_REQUEST';
export const ASSIGN_COURSES_REQUEST = 'ASSIGN_COURSES_REQUEST';
export const ASSIGN_COURSES_SUCCESS = 'ASSIGN_COURSES_SUCCESS';
export const ASSIGN_COURSES_FAILURE = 'ASSIGN_COURSES_FAILURE';
export const SHOW_COURSE_DETAILS = 'SHOW_COURSE_DETAILS';
export const HIDE_COURSE_DETAILS = 'HIDE_COURSE_DETAILS';
export const FETCH_COURSE_DETAILS_REQUEST = 'FETCH_COURSE_DETAILS_REQUEST';
export const FETCH_COURSE_DETAILS_SUCCESS = 'FETCH_COURSE_DETAILS_SUCCESS';
export const FETCH_COURSE_DETAILS_FAILURE = 'FETCH_COURSE_DETAILS_FAILURE';
export const GET_YEAR_GROUPS_REQUEST = 'GET_YEAR_GROUPS_REQUEST';
export const GET_CLASSROOMS_REQUEST = 'GET_CLASSROOMS_REQUEST';
export const SET_ASSIGN_UPF_COURSE = 'SET_ASSIGN_UPF_COURSE';

export const GET_ADMIN_DEFAULT_COURSE_REQUEST = 'GET_ADMIN_DEFAULT_COURSE_REQUEST';
export const GET_ADMIN_DEFAULT_COURSE_SUCCESS = 'GET_ADMIN_DEFAULT_COURSE_SUCCESS';
export const GET_ADMIN_DEFAULT_COURSE_FAILURE = 'GET_ADMIN_DEFAULT_COURSE_FAILURE';



// WEBPACK FOOTER //
// ./app/containers/manage-assigned-courses/action-types.js